function getDateForLiveblog(date, isPreview) {
  if (isPreview) {
    return null;
  }
  const partes = date.split('T');
  const horaMinutosSegundos = partes[1]?.split(':');
  if (!partes[1]) {
    return date;
  }
  for (var i = 0; i < horaMinutosSegundos.length; i++) {
    if (horaMinutosSegundos[i].length === 1) {
      horaMinutosSegundos[i] = "0" + horaMinutosSegundos[i];
    }
  }
  const fechaFormateada = partes[0] + 'T' + horaMinutosSegundos.join(':');
  return fechaFormateada;
};

export const isValidDate = (dateString) => {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return regex.test(dateString);
}

const LdJsonLiveblogs = ({
  newsData
}) => {
  
    const liveblogBody = newsData.body.filter(el => el.type === "liveblog")
    const liveBlogBodies = liveblogBody.map((liveBlogItem) => liveBlogItem.value.body.filter(item => item.type === 'text'));

    let publishedDateFormatZ;
    try {
      publishedDateFormatZ = new Date(newsData.publishedDate).toISOString();
    } catch (e) {
      publishedDateFormatZ = new Date().toISOString();
    }

    let endDateFormatZ;
    let endDate = new Date(newsData.publishedDate);
    endDate.setHours(endDate.getHours() + 23);

    try {
      endDateFormatZ = new Date(endDate).toISOString();
    } catch (e) {
      endDate = new Date();
      endDate.setHours(endDate.getHours() + 23);
      endDateFormatZ = endDate.toISOString();
    }
    
    let customBreadcrum;

  let dateModified;
  try {
    dateModified = new Date(newsData?.lastModified).toISOString();
  } catch (e) {
    dateModified = new Date().toISOString();
  }

  const descriptionStripped = newsData.summary
    ? newsData.summary.replace(/<[^>]*>?/g, "")
    : "";

  if (newsData.sections && newsData.sections.length > 0) {
    customBreadcrum = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": []
    }

    const breadList = newsData.sections.map((section, index) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "name": section.name?.toUpperCase(),
        "item": `${process.env.NEXT_PUBLIC_DOMAIN_URL}${newsData.sectionUrl}`
      }

    })

    customBreadcrum.itemListElement = breadList;
  }

  const updatedNoticias = liveBlogBodies.map((subArray) => {
    return subArray.map((noticia) => {
      const { type, ...rest } = noticia;
      const valueWithoutTag = noticia.value.replace(/<\/?[^>]+(>|$)/g, "");
      return {
        ...rest,
        "@type": "BlogPosting",
        description: valueWithoutTag,
        value: valueWithoutTag,
      };
    });
  });
  const liveBlogUpdates = [];

  for (let i = 0; i < liveBlogBodies.length; i++) {
    const subarrayNoticias = updatedNoticias[i]; // Obtenemos el subarray de noticias actual

    for (let j = 0; j < subarrayNoticias.length; j++) {
      const noticia = subarrayNoticias[j]; // Obtenemos la noticia actual del subarray 

      let dateParagraph = noticia.dateParagraph;
      // let dateParagraph = noticia.dateParagraph ? noticia.dateParagraph.replace(/ /g, 'T').replace("::", ":") : null;
      // const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
      // if (dateParagraph !== null && regex.test(dateParagraph)) {
      //   dateParagraph = (getDateForLiveblog(dateParagraph));
      // }

      try {
        if (dateParagraph === null) {
          dateParagraph = ""
        } else {
          dateParagraph = new Date(dateParagraph).toISOString();
        }
      } catch (e) {
        console.log("Check e:", e);
        dateParagraph = dateModified ? dateModified : new Date().toISOString();
      }

      const author = noticia.authorParagraph
        ? {
          type: "Person",
          name: noticia.authorParagraph?.name,
          url: "https://www.ellitoral.com/autor/" + noticia.authorParagraph?.slug + ".html",
        }
        : {
          type: "Organization",
          name: "Diario El Litoral",
          url: "https://www.ellitoral.com",
        };

      const liveBlogUpdate = {
        "@type": "BlogPosting",
        headline: newsData.title,
        alternativeHeadline: descriptionStripped,
        datePublished: dateParagraph,
        dateModified: dateParagraph,
        articleBody: noticia.description,
        url: newsData.url,
        author,
        "publisher": {
          "@type": "Organization",
          "name": "Diario El Litoral",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.ellitoral.com",
            "width": 439,
            "height": 60,
          },
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": newsData.url,
        },
        image: {
          "@type": "ImageObject",
          url: newsData.related_image_url,
          height: 1256,
          width: 620,
        },
      };

      liveBlogUpdates.push(liveBlogUpdate);
    }
  }

  let data = [];

  const liveBlogUpdateOld = {
    "@type": "BlogPosting",
    "headline": newsData.title,
    "alternativeHeadline": descriptionStripped,
    "datePublished": newsData?.publishedDate,
    "dateModified": dateModified,
    "articleBody": '',
    "url": newsData.url,
    "publisher": {
      "@type": "Organization",
      "name": "Diario El Litoral",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.ellitoral.com",
        "width": 439,
        "height": 60,
      },
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": newsData.url,
    },
    "image": {
      "@type": "ImageObject",
      "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
      "height": 439,
      "width": 60,
    },
  };

  const LdArticle = {
    "@context": "http://schema.org",
    "@type": "LiveBlogPosting",
    "@id": newsData.url + "#liveBlogPosting",
    "headline": newsData.title,
    "description": descriptionStripped,
    "coverageStartTime": publishedDateFormatZ,
    "datePublished": publishedDateFormatZ,
    "dateModified": dateModified,
    "coverageEndTime": endDateFormatZ,
    "url": newsData.url,
    "image": [{
      "@context": "http://schema.org",
      "@type": "ImageObject",
      "url": newsData.related_image_url,
      "height": 655,
      "width": 1300
    }],
    "articleSection": newsData.sections.map((e) => e.name),
    "author": newsData.authors && newsData.authors.map((author) => ({ type: "Person", name: author.name, url: 'https://www.ellitoral.com/autor/' + author.slug })),
    "about": {
      "@type": "Event",
      "name": newsData.title,
      "startDate": publishedDateFormatZ,
      "endDate": endDateFormatZ,
      "description": descriptionStripped,
      "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "VirtualLocation",
        "name": "Diario El Litoral",
        "url": newsData.url
      },
      "organizer": {
        "@type": "Organization",
        "name": "Diario El Litoral",
        "url": "https://www.ellitoral.com",
      },
      "performer": {
        "@type": "Organization",
        "name": "Diario El Litoral",
        "url": "https://www.ellitoral.com",
      },
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "price": "0.00",
        "priceCurrency": "ARS",
        "validFrom": publishedDateFormatZ,
        "url": newsData.url,
      },
      "image": {
        "@type": "ImageObject",
        "url": newsData.related_image_url,
        "height": 430,
        "width": 60,
      }
    },
    "publisher": {
      "@type": "Organization",
      "name": "Diario El Litoral",
      "url": "https://www.ellitoral.com",
      "logo": {
        "@type": "ImageObject",
        "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
        "width": 439,
        "height": 60
      },
      "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://www.youtube.com/c/EllitoralArgentina"]
    },

    "liveBlogUpdate": liveBlogUpdates,
  };
  data.push(LdArticle);

  if (customBreadcrum) {
    data.push(customBreadcrum);
  }

  return (
    <>
      {
        liveblogBody.length > 0 && (

          <script
            type="application/ld+json"
            data-script="beforeInteractive"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(data)
            }}
          />

        )
      }
    </>
  );
}

export default LdJsonLiveblogs;